<section class="sh-dialog__content med-overflow-container">
    <med-webservice-advanced-search-container [webserviceConfig]="webserviceConfig" [multiple]="multiple" (selected)="onSelection($event)">
    </med-webservice-advanced-search-container>
</section>
<footer class="sh-dialog__footer">
    <div class="sh-action-group -sh-align-end">
        <button type="button" class="sh-button sh-action-group__item" (click)="submit()" [disabled]="(selection$ | async)?.length === 0">
            {{dialogConfig.data.yes}}
        </button>
        <button type="button" class="sh-button--secondary sh-action-group__item" (click)="cancel()">{{dialogConfig.data.no}}</button>
    </div>
    <div class="sh-action-group -sh-align-end"></div>
</footer>
